import { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import InfoMessage from "@/client/components/InfoMessage";

type StatusInfoProps = { placement?: ComponentProps<typeof InfoMessage>['placement'] }
export default function StatusInfo({ placement }: StatusInfoProps) {
    const { t } = useTranslation()
    return (
        <InfoMessage placement={placement || 'right'}>
            <table>
                <tbody>
                    <tr>
                        <td>{t('Active')}:</td>
                        <td>
                            {t(
                                'When you activate the subscription, it starts immediately and the next billing date will be calculated. Except you activate a paused subscription.'
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>{t('Paused')}:</td>
                        <td>
                            {t(
                                'You can pause the subscription at any time. The subscription will run until the next billing date.'
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>{t('Terminated')}:</td>
                        <td>
                            {t(
                                'When you terminate your subscription, all projects will be terminated too. Terminated accounts can not be unterminated. You have to create a new subscription.'
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>{t('Blocked')}:</td>
                        <td>
                            {t(
                                'In the event of payment discrepancies, your subscription may be temporarily suspended. If this happens, you will be informed here of the reason and how you can lift the suspension.'
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </InfoMessage>
    )
}
